export default __webpack_public_path__ + "static/media/mkk.7e2245bf.png";